var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./GalleriaThumbnails.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5cfaf9d8\"}!../../vue-loader/lib/selector?type=template&index=0!./GalleriaThumbnails.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/primevue/galleria/GalleriaThumbnails.vue
// module id = 1975
// module chunks = 0